import { type AxiosResponse } from 'axios'

import axiosInstance from 'api/axiosInstance'
import { type GetNewPostsResponse } from 'types/api/feed'
import type { IHomeFeedCursorPage, IPostsFeedApiResponse, IPostsFeedCursorPage } from 'types/interfaces/ITypes'

export async function getUsersFeedInfinite(
  userId: string,
  params: { cursor?: string; [k: string]: any },
  signal?: AbortSignal
): Promise<IPostsFeedCursorPage> {
  const { data } = await axiosInstance.get<IPostsFeedApiResponse>(`/api/user/${userId}/feed`, {
    params,
    signal,
  })

  const nextCursor =
    typeof data?.meta?.next_cursor === 'string' && data.meta.next_cursor.length > 0
      ? data.meta.next_cursor
      : undefined

  return {
    page: { data },
    nextCursor,
  }
}
export const getHomeFeed = async (
  params: { list: string },
  cursor?: string | null
): Promise<IHomeFeedCursorPage> => {
  const { data } = await axiosInstance({
    method: 'GET',
    url: '/api/user/home',
    params: {
      list: params.list,
      ...(cursor ? { cursor } : {})
    }
  })

  return {
    page: { data },
    nextCursor: data?.meta?.next_cursor ?? undefined
  }
}

export const getDiscoveryFeed = async (
  params: {
    list: string
    type?: string
    per_page?: number
  },
  cursor?: string | null
): Promise<IHomeFeedCursorPage> => {
  const { data } = await axiosInstance({
    method: 'GET',
    url: '/api/user/discover',
    params: {
      list: params.list,
      type: params.type ?? 'all',
      per_page: params.per_page,
      ...(cursor ? { cursor } : {}),
    },
  })

  return {
    page: { data },
    nextCursor: data?.meta?.next_cursor ?? undefined,
  }
}

export const getNewPosts = async (lastCheck: string) => {
    const { data } = await axiosInstance<AxiosResponse<GetNewPostsResponse>>({
        method: 'POST',
        url: `/api/user/home/check`,
        data: {
            last_check: lastCheck
        }
    })

    return data
}
